import React, { useState } from 'react'

import kakao_icon from '@/assets/main/main7/kakao_icon.png'
import main7_xicon from '@/assets/main/main7/main7_Xicon.png'
import share_icon from '@/assets/main/main7/share_icon.png'
import { COLOR } from '@/shared/constant/color'
import { main7Item } from '@/shared/constant/main'
import { APP_STORE_WARD, IOS_APP_STORE_WARD, MO_APP_STORE_WARD } from '@/shared/constant/url'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { deviceDetection } from '@/shared/utils'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import {
  Main7LeftBottomContent,
  Main7LeftContent,
  Main7LeftMiddleContent,
  Main7LeftTopTab,
  Main7RightContent,
  Main7SectionTabBtn,
  Main7SectionWrap,
} from '@/styles/views/Main/main7'

const Main7Section = () => {
  const [selectItem, setSelectItem] = useState(0)

  const FindItem = (element: { idx: number }) => {
    return element.idx === selectItem
  }

  const { width } = useWindowDimensions()

  const onClickAppDownload = () => {
    switch (deviceDetection()) {
      case 'AOS':
        window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
        break
      case 'IOS':
        window.open(IOS_APP_STORE_WARD)
        break
    }
  }

  return (
    <Main7SectionWrap>
      {width < 1200 && (
        <section>
          <Main7SectionTabBtn
            color={`${selectItem < 5 && 'active'}`}
            onClick={() => setSelectItem(0)}
          >
            오늘의 운세
          </Main7SectionTabBtn>
          <Main7SectionTabBtn
            color={`${selectItem > 4 && 'active'}`}
            onClick={() => setSelectItem(5)}
          >
            오늘의 띠별운세
          </Main7SectionTabBtn>
        </section>
      )}
      <div>
        <Main7LeftContent>
          <div>
            <p>오늘의운세</p>
            <img src={main7_xicon} alt="" />
          </div>
          <Main7LeftTopTab>
            {main7Item.map((option) => (
              <React.Fragment key={option.idx}>
                {selectItem < 5 && option.idx < 5 && (
                  <span
                    className={`${option.idx === selectItem && 'active'}`}
                    onClick={() => {
                      setSelectItem(option.idx)
                    }}
                  >
                    {option.title}
                  </span>
                )}
                {selectItem > 4 && selectItem < 9 && option.idx > 4 && option.idx < 9 && (
                  <span
                    className={`${option.idx === selectItem && 'active'}`}
                    onClick={() => {
                      setSelectItem(option.idx)
                    }}
                  >
                    {option.title}
                  </span>
                )}
                {selectItem > 8 && selectItem < 13 && option.idx > 8 && option.idx < 13 && (
                  <span
                    className={`${option.idx === selectItem && 'active'}`}
                    onClick={() => {
                      setSelectItem(option.idx)
                    }}
                  >
                    {option.title}
                  </span>
                )}
                {selectItem > 12 && selectItem < 17 && option.idx > 12 && option.idx < 17 && (
                  <span
                    className={`${option.idx === selectItem && 'active'}`}
                    onClick={() => {
                      setSelectItem(option.idx)
                    }}
                  >
                    {option.title}
                  </span>
                )}
              </React.Fragment>
            ))}
          </Main7LeftTopTab>
          <Main7LeftMiddleContent>
            <span>
              <img src={main7Item?.find(FindItem)?.imgSrc} alt="" />
            </span>
            <div>
              <img src={share_icon} alt="" />
              <img src={kakao_icon} alt="" />
            </div>
          </Main7LeftMiddleContent>
          <Main7LeftBottomContent>
            <pre dangerouslySetInnerHTML={{ __html: main7Item?.find(FindItem)?.text }} />
          </Main7LeftBottomContent>
        </Main7LeftContent>
        <Main7RightContent>
          {main7Item.map((option) => (
            <React.Fragment key={option.idx}>
              {option.idx > 0 && (
                <section
                  className={`${selectItem === option.idx && 'active'}`}
                  onMouseEnter={() => {
                    setSelectItem(option.idx)
                  }}
                >
                  <img src={option.imgSrc} alt="" />
                </section>
              )}
            </React.Fragment>
          ))}
        </Main7RightContent>
      </div>
      {width > 1200 && (
        <CustomBtn
          color={COLOR.point1}
          bgColor={COLOR.white}
          borderColor={COLOR.point1}
          marginTop={'0px'}
          width={'296px'}
          fontSize={'18px'}
          height={'48px'}
          borderRadius={'40px'}
          fontFamily={'NanumSquareNeoHeavy, sans-serif'}
          onClick={onClickAppDownload}
        >
          <a>앱 설치하기</a>
        </CustomBtn>
      )}
    </Main7SectionWrap>
  )
}
export default Main7Section
